import { Link } from "react-router-dom";
import { Lock, AlertTriangle } from "react-feather";
import styles from "./billing.module.css";
import { ADDON_NAMES } from "./Features";
import { StorageGetItem, STORAGE_KEYS } from "./StorageComp";

// Shown in place of a page whose add-on the company has not enabled
const AddonRequired = ({ feature }) => {
  const auth = StorageGetItem(STORAGE_KEYS.AUTH);
  const name = ADDON_NAMES[feature] || "This feature";
  const isAdmin = auth?.user_type === 2;

  return (<div className={`${styles.GateWrap}`}>
    <div className={`${styles.GateCard}`}>
      <div className={`${styles.GateIcon}`}><Lock /></div>
      <h2 className={`${styles.GateTitle}`}>{name} is an add-on</h2>
      <p className={`${styles.GateText}`}>
        {isAdmin
          ? `Turn on ${name} to unlock this page for your whole team. It is added to your monthly bill and you can switch it off at any time.`
          : `${name} is not enabled for your company. Ask your company administrator to turn it on under Company Setting → Service Add-ons.`}
      </p>
      <div className={`${styles.GateActions}`}>
        {isAdmin && <Link to={`/company-profile?tab=addons&enable=${feature}`} className={`${styles.PrimaryBU}`}>View Service Add-ons</Link>}
        <Link to={"/dashboard"} className={`${styles.SecondaryBU}`}>Back to dashboard</Link>
      </div>
    </div>
  </div>);
}

// Customer portal / public pages when the company is suspended or the feature is off
export const ServiceUnavailable = ({ feature }) => {
  const name = feature ? (ADDON_NAMES[feature] || "This feature") : null;

  return (<div className={`${styles.GateWrap}`}>
    <div className={`${styles.GateCard}`}>
      <div className={`${styles.GateIcon}`}><AlertTriangle /></div>
      <h2 className={`${styles.GateTitle}`}>{name ? `${name} is not available` : "Service temporarily unavailable"}</h2>
      <p className={`${styles.GateText}`}>
        {name
          ? "This feature is not offered by this company at the moment."
          : "This service is temporarily unavailable. Please try again later or contact the company directly."}
      </p>
      <div className={`${styles.GateActions}`}>
        <Link to={"/"} className={`${styles.SecondaryBU}`}>Go to home page</Link>
      </div>
    </div>
  </div>);
}

export default AddonRequired;
